import React from 'react';
import styles from '../UIGameBarbarianInvasionTracker.module.scss';
import { T, Tooltip } from '@colonist/ui';
import clsx from 'clsx';
import IconSwords from '@static/images/icon_swords.svg';
const tooltipContent = [
    {
        key: 'strings:game.tips.knight.body.0'
    },
    {
        key: 'strings:game.tips.knight.body.1'
    }
];
export const UIGameBarbarianInvasionTrackerKnight = ({ knightStrength, arePlayersWinning, className })=>/*#__PURE__*/ React.createElement(Tooltip, {
        className: clsx(styles.iconWrapper, className),
        content: /*#__PURE__*/ React.createElement(React.Fragment, null, tooltipContent.map((item, i)=>/*#__PURE__*/ React.createElement("div", {
                className: styles.tooltipItem,
                key: i
            }, /*#__PURE__*/ React.createElement(T, {
                id: item
            })))),
        delay: 0,
        menuClassName: styles.tooltipMenu,
        position: "bottom-start",
        title: /*#__PURE__*/ React.createElement(T, {
            id: {
                key: 'strings:game.tips.knight.title'
            }
        })
    }, /*#__PURE__*/ React.createElement("img", {
        className: styles.icon,
        src: IconSwords
    }), /*#__PURE__*/ React.createElement("div", {
        className: clsx(styles.iconBadge, {
            [styles.green]: arePlayersWinning,
            [styles.red]: !arePlayersWinning
        })
    }, /*#__PURE__*/ React.createElement("span", null, knightStrength)));
